import { ComponentProps } from "react";

export function HiddenGemsStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M14.986 16.2674H25.0139L20.7105 7.58154H19.2895L14.986 16.2674ZM19.1132 35.4362V18.0516H4.63246L19.1132 35.4362ZM20.8974 35.4362L35.3675 18.0516H20.8974V35.4362ZM26.9999 16.2674H35.7499L32.1506 9.0185C31.9145 8.58047 31.5895 8.23147 31.1756 7.9715C30.7618 7.71153 30.3062 7.58154 29.8087 7.58154H22.7136L26.9999 16.2674ZM4.25 16.2674H13L17.2863 7.58154H10.1912C9.69376 7.58154 9.23812 7.71153 8.82429 7.9715C8.41043 8.23147 8.08901 8.58047 7.86004 9.0185L4.25 16.2674Z" />
        </svg>
    );
}
